import React from 'react';
import { SectionWrapper } from '../ui/SectionWrapper';
export function PresentationSection() {
  return <section className="py-20 px-4" data-id="element-124">
      <div className="max-w-3xl mx-auto" data-id="element-125">
        <SectionWrapper data-id="element-126">
          <div className="text-center mb-12" data-id="element-127">
            <span className="text-[var(--accent-teal)] tracking-widest uppercase text-sm font-bold mb-4 block" data-id="element-128">
              Presentando
            </span>
            <h2 className="text-4xl md:text-6xl text-[var(--text-primary)] mb-6" data-id="element-129">
              3AM Club
            </h2>
            <p className="text-xl md:text-3xl font-serif text-[var(--text-secondary)] italic" data-id="element-130">
              Protocolo de 14 Noches para Dormir en Perimenopausia (sin volverte
              loca)
            </p>
          </div>
        </SectionWrapper>

        <SectionWrapper delay={0.2} data-id="element-131">
          <div className="bg-gradient-to-br from-[var(--bg-card)] to-[var(--bg-deepest)] p-8 md:p-12 rounded-3xl border border-[var(--bg-card-hover)] text-center relative overflow-hidden" data-id="element-132">
            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-[var(--accent-teal)] to-transparent opacity-50" data-id="element-133"></div>

            <p className="text-lg md:text-xl text-[var(--text-primary)] leading-relaxed max-w-2xl mx-auto" data-id="element-134">
              Un PDF práctico (en español, para mujeres 40+ en USA) diseñado
              para una situación específica:
            </p>

            <div className="my-8 py-8 border-y border-[var(--bg-card-hover)]" data-id="element-135">
              <p className="text-2xl md:text-3xl font-serif text-[var(--accent-amber)] leading-tight" data-id="element-136">
                Te dormiste… y luego te despertaste entre las 2–4am… y ya no
                hubo vuelta.
              </p>
            </div>
          </div>
        </SectionWrapper>
      </div>
    </section>;
}